






























































































import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {EventInitState, EventType, FilterEvent, SeedEvent} from '@/store/event/event.types';
import {AuthEnum, RegisterEnum} from '@/store/auth/auth.enum';
import {Branch, BranchInitState} from '@/store/branch/branch.types';
import {LoginInfo} from '@/store/auth/auth.types';
import NewsDetailComponent from '@/components/news-activity/Detail.vue';
import BgThemePublic from '@/components/bg-theme-public.vue';

@Component({
  components: {
    NewsDetailComponent,
    BgThemePublic
  }
})
export default class NewsActivityComponent extends Vue {

  @State('branch') branchInitState!: BranchInitState;
  @State('event') eventState!: EventInitState;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;
  @Action('_getEventMemberForMember', {namespace: 'event'}) getEventMemberForMember!: (find: { filter: FilterEvent, branchId: string }) => Promise<void>;
  @Action('_getEventMemberForMainBranch', {namespace: 'event'}) getEventMemberForMainBranch!: (filter?: FilterEvent) => Promise<void>;
  @Action('_getEventMemberForBranchId', {namespace: 'event'}) getEventMemberForBranchId!: (filter?: FilterEvent) => Promise<void>;
  @Action('_getEventMemberForTime', {namespace: 'event'}) getEventMemberForTime!: (filter?: FilterEvent) => Promise<void>;
  @Action('_getFilesPrimary', {namespace: 'file'}) getFilesPrimary!: (payload: string) => Promise<void>;
  @Action('_getBranchForRegister', {namespace: 'branch'}) getBranchForRegister!: () => Promise<void>;

  public tabsIndex = 0;
  public loginInfo: LoginInfo = JSON.parse(localStorage.getItem(AuthEnum.Auth) as string) as LoginInfo;
  public readMoreTime = true;
  public readMoreMain = true;
  public readMoreBranch = true;
  public LessTime = false;
  public LessMain = false;
  public LessBranch = false;
  public branchId = '';
  public eventId = '';
  public newsTime = [] as SeedEvent[];
  public newsMain = [] as SeedEvent[];
  public newsBranch = [] as SeedEvent[];
  public branchList = [{id: ''}] as Branch[];
  public filterEventMain = {
    limit: '2',
    eventType: EventType.forMember,
    eventStatus: true
  } as FilterEvent;

  public filterEventBranch = {
    limit: '2',
    eventType: EventType.forMember,
    eventStatus: true
  } as FilterEvent;

  public filterEventTime = {
    limit: '5',
    eventType: EventType.forTime,
    eventStatus: true
  } as FilterEvent;

  async mounted() {
    await this.getBranchForRegister();
    this.branchList = this.branchInitState.branchs.filter((r) => {
      return r.branchNo !== '000'
    });
    await this.Loading(true);
    await this.fetchData();
    this.newsMain = this.eventState.eventMemberMain;
    this.newsTime = this.eventState.eventTime;
    this.newsBranch = this.eventState.eventMember;
    await this.Loading(false)
  }

  async fetchData() {
    await this.getEventMemberForMainBranch(this.filterEventMain);
    await this.getEventMemberForTime(this.filterEventTime);
    if (this.loginInfo) {
      this.branchId = this.loginInfo.branchId
    } else {
      this.branchId = this.branchList[0].id as string;
    }
    await this.getEventMemberForMember({
      filter: this.filterEventBranch,
      branchId: this.branchId
    });
  }

  async popUpEvent(event: SeedEvent) {
    console.log('DEBUG: popUpEvent');
    this.eventId = event.id || '';
    this.popUpStatus(true);
  }

  async popUpStatus(status: boolean) {
    console.log('DEBUG: close', status);
    status ? this.$bvModal.show('my-modal') : this.$bvModal.hide('my-modal');
  }

  async loadMoreBranch() {
    this.Loading(true);
    this.filterEventBranch.limit = (Number(this.filterEventBranch.limit) + 10).toString();
    await this.getEventMemberForMember({
      filter: this.filterEventBranch,
      branchId: this.branchId
    });
    this.LessBranch = true;
    if (Number(this.filterEventBranch.limit) > this.newsTime.length) {
      this.readMoreBranch = false;
    }
    this.newsBranch = this.eventState.eventMember;
    this.Loading(false);
  }

  async ShowLessBranch() {
    this.Loading(true);
    this.filterEventBranch.limit = '2';
    await this.getEventMemberForMember({
      filter: this.filterEventBranch,
      branchId: this.branchId
    });
    this.LessBranch = false;
    this.readMoreBranch = true;
    this.newsBranch = this.eventState.eventMember;
    this.Loading(false);
  }

  async loadMoreTime() {
    this.Loading(true);
    this.filterEventTime.limit = (Number(this.filterEventTime.limit) + 5).toString();
    await this.getEventMemberForTime(this.filterEventTime);
    this.newsTime = this.eventState.eventTime;
    this.LessTime = true;
    if (Number(this.filterEventTime.limit) > this.newsTime.length) {
      this.readMoreTime = false;
    }
    this.Loading(false);
  }

  async ShowLessTime() {
    this.Loading(true);
    this.filterEventTime.limit = '5';
    await this.getEventMemberForTime(this.filterEventTime);
    this.newsTime = this.eventState.eventTime;
    this.LessTime = false;
    this.readMoreTime = true;
    this.Loading(false);
  }

  async loadMoreMain() {
    this.Loading(true);
    this.filterEventMain.limit = (Number(this.filterEventMain.limit) + 5).toString();
    await this.getEventMemberForMainBranch(this.filterEventMain);
    this.newsMain = this.eventState.eventMemberMain;
    this.LessMain = true;
    if (Number(this.filterEventMain.limit) > this.newsMain.length) {
      this.readMoreMain = false;
    }
    this.Loading(false);
  }

  async ShowLessMain() {
    this.Loading(true);
    this.filterEventMain.limit = '2';
    await this.getEventMemberForMainBranch(this.filterEventMain);
    this.newsMain = this.eventState.eventMemberMain;
    this.LessMain = false;
    this.readMoreMain = true;
    this.Loading(false);
  }

  async SelBranch() {
    this.Loading(true);
    await this.getEventMemberForMember({
      filter: this.filterEventBranch,
      branchId: this.branchId
    });
    this.newsBranch = this.eventState.eventMember;
    this.Loading(false);
  }

  convertHTML(html: string) {
    let isHTML = html;
    let div = document.createElement('div');
    div.innerHTML = isHTML;
    return div.textContent || div.innerText || '';
  }


}
